import styled from '@emotion/styled';
import { gray, primary, red } from '@styles/Colors';
import { TotalDataType } from '..';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';

type Props = {
  data: TotalDataType;
  isLast: boolean;
  currency?: string;
};

const Layout = styled.div`
  padding: 16px 10px;
  border-bottom: 1px solid ${gray.gray3};

  display: grid;
  grid-template-columns: 80px 1fr 1fr 1fr 1fr;
  column-gap: 24px;

  &:last-child {
    border-bottom: none;
  }
`;

const QuantityText = styled.div``;

export default function TableItem({ data, isLast, currency }: Props) {
  const variant = isLast ? TypoVariant.SH3 : TypoVariant.B3;

  return (
    <Layout>
      <Typography variant={variant} color={primary.gray}>
        {data.type}
      </Typography>
      {data.request_quantity ? (
        // 거래문서
        <QuantityText>
          <Typography
            variant={TypoVariant.B3}
            color={data.quantity !== data.request_quantity ? red.red2 : primary.gray}>
            {data.quantity}
          </Typography>
          <Typography variant={TypoVariant.B3} color={gray.gray4}>
            /{data.request_quantity}
          </Typography>
        </QuantityText>
      ) : (
        // 견적서 작성, 재작성
        <Typography variant={TypoVariant.B3} color={primary.gray}>
          {data.quantity}
        </Typography>
      )}

      <Typography variant={variant} color={primary.gray}>
        {currency !== 'USD' && data.supply_price}
      </Typography>
      <Typography variant={variant} color={primary.gray}>
        {currency !== 'USD' && data.vat}
      </Typography>
      <Typography variant={variant} color={primary.gray}>
        {data.total_price}
      </Typography>
    </Layout>
  );
}
